module.exports = __webpack_public_path__ + "static/media/snappy-hero.60016e70.svg";